import { AllocationRunOutput, SecuredAllocationType } from '@/cip/_openapi/portfolio-optimizer';

export interface PolicySecuredTargets {
    amount?: number;
    percentage?: number | 'mixed';
}

export const summarizePolicySecuredTargets = (
    allocation: AllocationRunOutput | undefined,
    accountGUIDs: string[],
): PolicySecuredTargets => {
    if (!allocation || accountGUIDs.length === 0) return {};
    const scope = new Set(accountGUIDs);
    const securedness = [...scope].map((guid) => allocation.securedness.find((item) => item.accountGuid === guid));
    // Missing accounts are not evidence of zero coverage.
    if (securedness.some((item) => !item)) return {};
    // The optimizer returns null targets for accounts without Lifestyle protection.
    // Those inactive accounts must not hide another account's valid policy target.
    const percentages = securedness
        .filter((item) => item?.initialSecuredness !== 0 || item?.targetSecuredness != null)
        .map((item) => item?.targetSecuredness);
    const percentagesKnown =
        percentages.length > 0 &&
        percentages.every((value) => value != null && Number.isFinite(value) && value >= 0 && value <= 1);
    const amounts = allocation.targetAllocations
        .filter((item) => scope.has(item.accountGuid) && item.allocationType === SecuredAllocationType.PAYDAY_BOND)
        .map((item) => item.targetExposure);
    return {
        amount: amounts.every((value) => Number.isFinite(value) && value >= 0)
            ? amounts.reduce((sum, value) => sum + value, 0)
            : undefined,
        // Securedness is not an AUM percentage. The response does not provide the
        // withdrawal-liability denominator needed for a weighted policy rollup.
        percentage: percentagesKnown
            ? percentages.every((value) => value === percentages[0])
                ? percentages[0]
                : 'mixed'
            : undefined,
    };
};
